import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import BeeSVG from './BeeSVG';

const SplashScreen = ({ onReady }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    let resolved = false;

    const finish = () => {
      if (resolved) return;
      resolved = true;
      setFadeOut(true);
      setTimeout(onReady, 400);
    };

    // Resolve when Google Maps is loaded or after 1.5s timeout
    const timeout = setTimeout(finish, 1500);

    const checkMaps = () => {
      if (window.google?.maps) {
        finish();
      }
    };
    checkMaps();
    const interval = setInterval(checkMaps, 100);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [onReady]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-gradient-to-br from-honey-50 via-white to-honey-100/50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-950 transition-opacity duration-400 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <BeeSVG className="w-20 h-20 animate-float" />
      <h1 className="mt-4 text-3xl font-bold honey-text-gradient">Beezy</h1>
      <p className="mt-2 text-sm text-gray-400 dark:text-gray-500 font-light">
        Finding the perfect moment...
      </p>
    </div>
  );
};

SplashScreen.propTypes = {
  onReady: PropTypes.func.isRequired,
};

export default SplashScreen;
